import { Box, Typography } from "@mui/material"
import { translate } from "app/language/service"
import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { openColorPickerPopup } from "ui/tools/color-picker-popup"
import { IUIConfiguration, IUIConfigurationColor } from "../model"

interface IUiConfigColorPickerProps {
  title: string
  color: IUIConfigurationColor
  uiConfig: IUIConfiguration
  setColor: (color: IUIConfigurationColor) => any
}

export const UiConfigColorPicker = React.memo(({ title, color, uiConfig, setColor }: IUiConfigColorPickerProps) => (
  <FlexBox vertical ai="start" gap=".5rem" sx={{ width: "10rem", mb: "1rem" }}>
    <Typography color="textPrimary" fontSize="1rem">
      {title}
    </Typography>
    <FlexBox
      gap
      jc="start"
      fullWidth
      onClick={() =>
        openColorPickerPopup({
          hexColor: color.light,
          setHexColor: (newColor: string) => setColor({ light: newColor, dark: color.dark }),
          title: translate("admin.ui-configuration.set.color.light")
        })
      }
      sx={{
        p: "1rem",
        pt: "0.5rem",
        pb: "0.5rem",
        border: "1px solid black",
        borderRadius: ".25rem",
        background: uiConfig.colors.backgroundDefault.light,
        cursor: "pointer"
      }}>
      <Box
        sx={{
          width: "2rem",
          height: "2rem",
          backgroundColor: color.light,
          border: "1px solid darkgrey",
          borderRadius: ".125rem"
        }}
      />
      <FlexBox vertical>
        <Typography color="textSecondary" fontSize=".9rem">
          {translate("label.light")}
        </Typography>
        <Typography color="textSecondary" fontSize=".8rem">
          {color.light}
        </Typography>
      </FlexBox>
    </FlexBox>
    <FlexBox
      gap
      jc="start"
      fullWidth
      onClick={() =>
        openColorPickerPopup({
          hexColor: color.dark,
          setHexColor: (newColor: string) => setColor({ light: color.light, dark: newColor }),
          title: translate("admin.ui-configuration.set.color.dark")
        })
      }
      sx={{
        p: "1rem",
        pt: "0.5rem",
        pb: "0.5rem",
        border: "1px solid black",
        borderRadius: ".25rem",
        background: uiConfig.colors.backgroundDefault.dark,
        cursor: "pointer"
      }}>
      <Box
        sx={{
          width: "2rem",
          height: "2rem",
          backgroundColor: color.dark,
          border: "1px solid lightgrey",
          borderRadius: ".125rem"
        }}
      />
      <FlexBox vertical>
        <Typography color="textSecondary" fontSize=".9rem">
          {translate("label.dark")}
        </Typography>
        <Typography color="textSecondary" fontSize=".8rem">
          {color.dark}
        </Typography>
      </FlexBox>
    </FlexBox>
  </FlexBox>
))
